import { useSelector, useDispatch } from "react-redux";
import { getReaderView } from "../../../api/features/content-controls/enhanced/selectors";
import { setReaderView } from "../../../api/features/content-controls/enhanced/actions";
import { ReaderView } from "../../../api/features/content-controls/enhanced/utils";

export default function useReaderView() {
  const dispatch = useDispatch();
  const currentReaderView = useSelector(getReaderView);
  const setView = (readerView: ReaderView) => {
    dispatch(setReaderView(readerView));
  };

  return {
    currentReaderView,
    setReaderView: setView,
  };
}
